// extracted by mini-css-extract-plugin
module.exports = {"content":"RentalOffer_content__IEsmO","deliveryContainer":"RentalOffer_deliveryContainer__nZ1G0"};